import { createSelector } from "reselect";
import { selectCreateShipmentForm } from "./selectCreateShipmentForm";

export const selectTotalMixedSkuPackages = createSelector(
  selectCreateShipmentForm,
  (createShipment) =>
    [...new Set(createShipment?.mixedSkuPackages?.map((pkg) => pkg.items?.map((item) => item.dsku)).flat())].length
);
